import {
  ActionIcon,
  Button,
  Card,
  Image,
  Paper,
  SimpleGrid,
  Text,
} from "@mantine/core";
import React from "react";
import { Link } from "react-router-dom";
import { Eye, UserMinus } from "tabler-icons-react";
import { userTypes } from "../../AdminPages/Users/userTypes";
import { unfollowFunction } from "../../JobSeekerPages/jobSeekerHelperFunctions/jobseekerHelpers";

const CompaniesIFollow = ({ followers, refresh, setRefresh, setLoading }) => {
  console.log("Companies i follow", followers);
  const card = followers?.map((data, index) => {
    if (data.role === userTypes.Companies) {
      return (
        <Card
          key={index}
          radius={"md"}
          sx={{
            border: "1px solid #E32339",
            borderRadius: "0.5rem",
            ":hover": {
              boxShadow: "0 5px 12px #0003",

              // transform: "scale(1.005)",
            },
            boxShadow: "0 2px 8px #00000026",
            transition: "box-shadow .2s",
            transitionDuration: "0.2s",
            transitionTimingFunction: "ease",
            transitionDelay: "0s",
            transitionProperty: "box-shadow",
          }}
          style={{ width: "302px" }}
        >
          <Card.Section
            style={{ height: "201px", position: "relative" }}
            withBorder
          >
            <Image
              withPlaceholder
              height={"201px"}
              width={"100%"}
              fit={"cover"}
              src={data?.companyProfileInfo?.[0]?.companyLogo}
            />
            <div style={{ position: "absolute", top: 0, right: 0, margin: 8 }}>
              <ActionIcon
                radius={"xl"}
                variant="filled"
                color={"red.9"}
                onClick={() => {
                  unfollowFunction(data._id, setLoading, refresh, setRefresh);
                }}
              >
                <UserMinus />
              </ActionIcon>
            </div>
            <div
              style={{ position: "absolute", bottom: 0, right: 0, margin: 8, display:'flex', gap:'5px' }}
            >
              <Button
                sx={{
                  ":hover": {
                    color: "#fff",
                  },
                }}
                variant="filled"
                color={"red.9"}
                component={Link}
                to={`/jobSeeker/companyPosts/${data._id}`}
                uppercase
              >
                Updates
              </Button>
              <Button
                sx={{
                  ":hover": {
                    color: "#fff",
                  },
                }}
                variant="filled"
                color={"red.9"}
                component={Link}
                to={`/jobSeeker/company/companyprofile/${data._id}`}
                uppercase
              >
                View
              </Button>
            </div>
          </Card.Section>
          <Card.Section>
            <Paper p={"md"}>
              <Text lineClamp={1} weight={500} size={"lg"}>
                {data?.companyProfileInfo?.[0]?.companyName}
              </Text>

              <Text>{data?.companyProfileInfo?.[0]?.companyTagLine}</Text>
            </Paper>
          </Card.Section>
        </Card>
      );
    } else if (data.role !== userTypes.Companies) {
      console.log("Its not a company");
    }
  });

  return (
    <SimpleGrid
      cols={5}
      spacing="md"
      breakpoints={[
        { maxWidth: 1750, cols: 3, spacing: "md" },
        { maxWidth: "xl", cols: 3, spacing: "md" },
        { maxWidth: "lg", cols: 2, spacing: "md" },
        { maxWidth: "md", cols: 2, spacing: "md" },
        { maxWidth: "sm", cols: 1, spacing: "sm" },
        { maxWidth: "xs", cols: 1, spacing: "sm" },
      ]}
    >
      {card}
    </SimpleGrid>
  );
};

export default CompaniesIFollow;
